import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

import login from '@/views/login'
// 员工端
import staff from '@/views/staff'
import staffInfo from '@/views/staff/info'
import staffSalary from '@/views/staff/salary'
import staffSalaryInfo from '@/views/staff/salary/Info'
// 管理端
import manager from '@/views/manager'
import managerCompany from '@/views/manager/company'
import managerManagers from '@/views/manager/managers'
import managerStaff from '@/views/manager/staff'
import managerStaffExpandKey from '@/views/manager/staffExpandKey'
import managerSalaryReport from '@/views/manager/salaryReport'
import managerNoAuth from '@/views/manager/noAuth'

// import HelloWorld from '@/components/HelloWorld'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: login,
  },
  // {
  //   path: '/HelloWorld',
  //   name: 'HelloWorld',
  //   component: HelloWorld,
  // },
  {
    path: '/login/:type',
    name: 'loginManager',
    component: login,
  },
  {
    path: '/',
    redirect: '/login',
  },
  {
    path: '/staff',
    component: staff,
    children: [
      {
        path: '/',
        name: 'staffInfo',
        component: staffInfo,
      },
      {
        path: '/staff/salary',
        name: 'staffSalary',
        component: staffSalary,
      },
      {
        path: '/staff/salaryInfo',
        name: 'staffSalaryInfo',
        component: staffSalaryInfo,
      },
    ],
    meta: {
      requireAuth: true,
    },
  },
  {
    path: '/manager',
    component: manager,
    children: [
      {
        path: '/manager/company',
        name: 'managerCompany',
        component: managerCompany,
      },
      {
        path: '/manager/noAuth',
        name: 'managerNoAuth',
        component: managerNoAuth,
      },
      {
        path: '/manager',
        redirect: '/manager/company',
      },
      {
        path: '/manager/managers',
        name: 'managerManagers',
        component: managerManagers,
      },
      {
        path: '/manager/staff',
        name: 'managerStaff',
        component: managerStaff,
      },
      {
        path: '/manager/salaryReport',
        name: 'managerSalaryReport',
        component: managerSalaryReport,
      },
      {
        path: '/manager/staffExpandKey',
        name: 'managerStaffExpandKey',
        component: managerStaffExpandKey,
      },
    ],
    meta: {
      requireAuth: true,
    },
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

export function requireRouter(_obj) {
  let newRouter = [
    {
      path: '/manager',
      component: (resolve) => require(['@/views/manager'], resolve),
      children: _obj.map((_item) => {
        return {
          path: '/manager/' + _item.menu_path,
          component: (resolve) =>
            require(['@/views/manager/' + _item.menu_path], resolve),
        }
      }),
    },
  ]
  router.addRoutes(newRouter)
}

export default router
